export default abstract class BaseIcon extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });

    const wrapper = document.createElement('div');
    wrapper.setAttribute('class', 'icon');
    wrapper.innerHTML = this.renderSVG();

    const style = document.createElement('style');
    style.textContent = `
      :host {
        display: inline-block;
        width: 16px;
        height: 16px;
      }
      svg {
        height: 100%;
        width: 100%;
      }
    `;

    this.shadowRoot?.append(style, wrapper);
  }

  static get observedAttributes() {
    return ['style'];
  }

  attributeChangedCallback(name: string, _oldValue: string, newValue: string) {
    if (name === 'style') {
      this.shadowRoot?.querySelector('.icon')?.setAttribute('style', newValue);
    }
  }

  abstract renderSVG(): string;
}
